import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { QcsTypography } from '../common/basic/QcsTypography';
import { CopyButton } from './CopyableBlock';
import { ConnectionDetails, formatConnectionText, getConnectionRows } from './integrationUtils';

interface Props {
  details: ConnectionDetails;
  //For sending everything to the partner at once - labelled, like in the credentials file.
  copyAll?: boolean;
}

/** Each value is copied on its own, without its label - it goes into a config or a tool as it is. */
export const IntegrationConnectionDetails: FC<Props> = ({ details, copyAll }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {/* The label stays outside the code - it's what the value is, not a part of it. */}
      <Box sx={{ display: 'grid', gridTemplateColumns: 'max-content minmax(0, 1fr)', alignItems: 'center', columnGap: 2, rowGap: 1 }}>
        {getConnectionRows(details).map(({ label, value }) => (
          <Fragment key={label}>
            <QcsTypography variant="body2" sx={{ color: 'text.secondary' }}>
              {label}
            </QcsTypography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, backgroundColor: 'grey.100', borderRadius: 1, pl: 1.5, pr: 0.5, py: 0.25 }}>
              <Box sx={{ flex: 1, fontFamily: 'monospace', fontSize: '0.8rem', wordBreak: 'break-all' }}>{value}</Box>
              <CopyButton text={value} />
            </Box>
          </Fragment>
        ))}
      </Box>
      {copyAll && (
        <CopyButton text={formatConnectionText(details)} label={t('integration.apiAccess.credentials.copyAll')} sx={{ alignSelf: 'flex-start' }} />
      )}
    </Box>
  );
};
